import { createFileRoute } from '@tanstack/react-router';
import { TransactionalSendRoute } from '@/pages/workspaces/transactional/message/overview/send/routing';

function TransactionalSendTabRoute() {
  const { transactionalMessageId } = Route.useParams();
  return <TransactionalSendRoute transactionalMessageId={transactionalMessageId} />;
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/overview/send',
)({
  component: TransactionalSendTabRoute,
});
